<template>
  <div class="personal">
    <section class="personal-section">
      <p class="sec-head">账户信息</p>
      <div class="sec-body">
        <img src="static/personal.png" />
        <div class="sec-body-info">
          <p>
            账户名称：<span>{{ list.username }}</span>
          </p>
          <p>
            使用人：<span>{{ list.nickname }}</span>
          </p>
          <p>
            联系方式：<span>{{ list.phone }}</span>
          </p>
        </div>
        <div class="sec-body-info">
          <p>
            职位名称：<span>{{ list.duty }}</span>
          </p>
          <p>
            机构权限：<span>{{ accessList.join('、') }}</span>
          </p>
        </div>
      </div>
    </section>
    <section class="personal-section">
      <p class="sec-head">修改密码</p>
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="原密码" prop="old">
          <el-input
            type="password"
            v-model="ruleForm.old"
            autocomplete="off"
            placeholder="请输入原密码"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="pass">
          <el-input
            type="password"
            v-model="ruleForm.pass"
            autocomplete="off"
            placeholder="请输入新密码"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码确认" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            placeholder="请再次输入新密码"
            maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确认修改</el-button
          >
          <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form-item>
      </el-form>
      <!-- <div class="sec-form">
                <div class="sec-form-row">
                    <label>原密码</label>
                    <el-input v-model="old" class="sec-form-row-input" type="password" placeholder="请输入原密码"></el-input>
                </div>
                <div class="sec-form-row">
                    <label>新密码</label>
                    <el-input v-model="newPwd" class="sec-form-row-input" type="password" placeholder="请输入新密码"></el-input>
                </div>
                <div class="sec-form-row">
                    <label>新密码确认</label>
                    <el-input v-model="newCopyPwd" class="sec-form-row-input" type="password" placeholder="请再次输入新密码"></el-input>
                </div>
                <div class="sec-form-row sec-form-foot">
                    <label></label>
                    <el-button type="primary" @click="editPwd">确认修改</el-button>
                </div>
            </div> -->
    </section>
  </div>
</template>

<script>
import { getAccountDetails, updateUserPwd } from '../../api/api'
import {getLoginPath} from "../../utils";
export default {
  name: 'sd-personal',
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'))
      } else {
        if (this.ruleForm.old !== '') {
          // this.$refs.ruleForm.validateField('old');
        }
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        const rex = /^[A-Za-z0-9]+$/
        const validAbc = /[a-z]/i
        const validnNum = /[0-9]/
        const regx = new RegExp(rex)
        if (value === this.ruleForm.old) {
          callback(new Error('新老密码不能一致!'))
        }
        // else if (value.length < 6 || value.length > 30) {
        //   callback(new Error('密码长度需控制在6-30位之间!'))
        // }
        else if (!regx.test(value)) {
          callback(new Error('密码只允许输入英文或数字!'))
        } else if (
          !(validAbc.test(value) && validnNum.test(value) && value.length >= 6)
        ) {
          callback(new Error('密码必须是数字+字母，且长度需控制在6-30位之间！'))
        } else {
          if (this.ruleForm.checkPass !== '') {
            // this.$refs.ruleForm.validateField('checkPass');
          }
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      list: [],
      accessList: [],
      ruleForm: {
        pass: '',
        checkPass: '',
        old: '',
      },
      rules: {
        old: [{ validator: validateOldPass, trigger: 'blur' }],
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getAccountDetails(JSON.parse(sessionStorage.getItem('user')).id)
    if(sessionStorage.getItem('resetPwd')==='A'){
      this.$message.warning("请先修改密码！")
    }
  },
  methods: {
    // 得到账户详情
    getAccountDetails(id) {
      getAccountDetails(id).then((res) => {
        this.list = Object.assign({}, res.data)
        let orgList = JSON.parse(JSON.stringify(this.list)).sourcePermissions
        let accessList = []
        for (let i = 0, j = orgList.length; i < j; i++) {
          let citys = orgList[i].cityNames.join(',')
          if (orgList[i].cityNames.length > 1) {
            accessList.push(orgList[i].sourceName + '(' + citys + ')')
          } else {
            accessList.push(orgList[i].sourceName)
          }
        }
        this.accessList = JSON.parse(JSON.stringify(accessList))
        //NProgress.done();
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let para = {
            id: JSON.parse(sessionStorage.getItem('user')).id,
            newPassword: this.ruleForm.pass,
            oldPassword: this.ruleForm.old,
          }
          updateUserPwd(para).then((res) => {
            this.listLoading = false
            //NProgress.done();
            if (res.code == 200) {
              let loginPath = getLoginPath()
              this.$message({
                message: '密码修改成功',
                type: 'success',
              })
              this.$store.dispatch('FedLogOut').then(() => {
                console.log(loginPath)
                this.$router.replace({
                  path:loginPath
                })
                location.reload() // 为了重新实例化vue-router对象 避免bug
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
            this.getList()
          })
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.personal {
  .personal-section {
    .sec-head {
      padding: 10px;
      background: #e6effb;
      width: calc(100% - 20px);
      font-size: 14px;
      font-weight: 600;
    }
    .sec-body {
      padding: 10px;
      width: calc(100% - 20px);
      display: flex;
      img {
        width: 100px;
        height: 100px;
      }
      .sec-body-info {
        margin-left: 20px;
        p {
          font-size: 14px;
          span {
            font-size: 14px;
            color: #888888;
          }
        }
        &:last-child {
          margin-left: 42px;
        }
      }
    }
    .sec-form {
      padding: 10px;
      width: calc(100% - 20px);
      .sec-form-row {
        display: flex;
        width: 100%;
        margin-bottom: 12px;
        label {
          width: 100px;
          height: 36px;
          line-height: 36px;
          text-align: right;
          margin-right: 12px;
          font-size: 14px;
        }
        .sec-form-row-input {
          height: 36px;
          line-height: 36px;
          width: calc(50% - 100px);
          .el-input__inner {
            height: 36px;
            line-height: 36px;
            font-size: 14px;
          }
        }
      }
      .sec-form-foot {
        margin-top: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// personal.vue?83585384